import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { scrollToId } from "./Navbar";

const SERVICES = [
  {
    n: "01",
    title: "Interior",
    blurb:
      "Rooms that feel finished, not just painted. Calm, meticulous work inside lived-in homes.",
    items: [
      "Walls, ceilings & trims",
      "Doors, skirting & window frames",
      "Feature walls & colour consultation",
      "Full prep, patch & prime",
    ],
    img: "https://customer-assets-agu9un31.emergentagent.net/job_after-paint-pro/artifacts/2i7xtmp5_interior.webp",
    alt: "Freshly painted interior by After Paint — crisp walls and clean lines",
    testid: "service-interior",
  },
  {
    n: "02",
    title: "Exterior",
    blurb:
      "Australian weather is hard on homes. Thirty years of hard-won experience goes into every exterior spec.",
    items: [
      "Weatherboards, render & brick",
      "Coastal-grade, weather-hardy coatings",
      "Fences, decks & outdoor structures",
      "Pressure wash, scrape & full prep",
    ],
    img: "https://customer-assets-agu9un31.emergentagent.net/job_after-paint-pro/artifacts/7nwnuuci_After%20rotten.jpg",
    alt: "Freshly painted grey and navy weatherboard cottage exterior by After Paint",
    testid: "service-exterior",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 border-t border-line"
    >
      <div className="px-6 md:px-12 lg:px-24 mb-16 md:mb-24 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <Reveal>
            <SectionLabel>Services</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-8">
              Inside <span className="italic text-smoke">and</span> out.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="text-smoke font-light max-w-sm text-base leading-relaxed">
            One painter, start to finish. The person who quotes your job is the
            person who picks up the brush.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-line border-y border-line">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12} y={48} className="bg-coal">
            <article data-testid={s.testid} className="group bg-coal h-full">
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={s.img}
                  alt={s.alt}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-coal/20 group-hover:bg-coal/0 transition-colors duration-700" />
              </div>
              <div className="p-10 md:p-14">
                <h3 className="font-serif text-3xl md:text-4xl font-normal tracking-tight">
                  {s.title}
                </h3>
                <p className="text-smoke font-light mt-4 leading-relaxed">
                  {s.blurb}
                </p>
                <ul className="mt-8 space-y-3">
                  {s.items.map((item) => (
                    <li
                      key={item}
                      className="flex items-center gap-4 text-sm text-bone/85 font-light tracking-wide"
                    >
                      <span className="block w-4 h-px bg-ember shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`${s.testid}-cta`}
                  onClick={() => scrollToId("#quote")}
                  className="mt-10 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-ember hover:gap-4 transition-[gap] duration-300"
                >
                  Request this
                  <ArrowUpRight size={14} strokeWidth={1.5} />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
